import React, { Fragment, useState } from 'react';
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    InputAdornment,
    InputLabel,
    Menu,
    MenuItem,
    Select,
    TextField,
    Typography,
    FormLabel,
    RadioGroup,
    Radio,
    BottomNavigationAction,
    BottomNavigation,
    Chip,
    Button,
    Box,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
//import DateFnsUtils from '@date-io/date-fns';
//import {MuiPickersUtilsProvider, DatePicker} from '@material-ui/pickers';
import { FIELD_TYPES, displayCash } from '../utils/utils';
import LocationField from './LocationField';
import ListItemIcon from '@mui/material/ListItemIcon';
import FieldTitle from './FieldTitle';
import { useRef } from 'react';

const useStyles = makeStyles((theme) => ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    helperText: {
        whiteSpace: 'pre-line',
    },
}));

function BoldToggle(props) {
    const field = props.field
    const fieldsProps = props.fieldsProps

    const inputRef = useRef(null);
  
    const handleBoldClick = () => {
        const input = inputRef.current;
        if (!input) return;

        const value = fieldsProps.getValue(field.name, field.defaultValue)
    
        const start = input.selectionStart;
        const end = input.selectionEnd;
        const before = value.slice(0, start);
        const selected = value.slice(start, end);
        const after = value.slice(end);
    
        // Case 1: selected is already wrapped in **
        const isBolded = selected.startsWith('**') && selected.endsWith('**');
    
        let newValue;
        let newCursorStart = start;
        let newCursorEnd = end;
    
        if (isBolded) {
            // Remove ** from both sides
            const unwrapped = selected.slice(2, -2);
            newValue = before + unwrapped + after;
            newCursorEnd = start + unwrapped.length;
        } else if (selected.length > 0) {
            // Wrap with **
            newValue = before + '**' + selected + '**' + after;
            newCursorEnd = end + 4;
        } else {
            // No text selected → insert **** and move cursor inside
            newValue = before + '****' + after;
            newCursorStart = newCursorEnd = start + 2;
        }

        fieldsProps.handleChange({target:{name:field.name, value:newValue}})
    
        setTimeout(() => {
            input.focus();
            input.setSelectionRange(newCursorStart, newCursorEnd);
        }, 0);
    };

    return (<>
        <Button onClick={handleBoldClick} variant="contained" color='primary' size='small' style={{marginBottom:4}}>
            Bold
        </Button>
        <TextField inputRef={inputRef} name={field.name} label={field.label} margin="none" fullWidth variant={field.variant}
            required={field.required||false} value={fieldsProps.getValue(field.name, field.defaultValue)} onChange={fieldsProps.handleChange}
            multiline helperText={field.helperText} type={field.inputType} minRows={field.rows} maxRows={field.rowsMax} onFocus={fieldsProps.handleFocus} onBlur={fieldsProps.handleBlur}  placeholder={field.placeholder}
        />
    </>)
}

export function Fields(props) {
    const fields = props.fields || []
    const showData = props.showData || false

    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOptions, setMenuOptions] = useState([]);
    const [optionField, setOptionField] = useState();

    const changeTimeout = useRef(null);

    const handleChangeCheckBox = (event) => {
        props.handleChange({target:{name:event.target.name, value:event.target.checked}})
        //props.handleChangeFinal(event.target.name, event.target.checked)
    };

    const handleChangeWithDelay = e => {
        const { name, value } = e.target;

        if (changeTimeout.current) {
            clearTimeout(changeTimeout.current);
        }

        changeTimeout.current = setTimeout(() => {
            props.handleChange({target:{name, value}})
        }, 300); 
    }

    const getCurrencyValue = (fieldName, defaultValue) => {
        const currenciesLabels = {'ILS':'₪', 'USD':'$', 'EUR':'€', 'GBP':'£'}
        const value = props.getValue(fieldName, defaultValue)
        return currenciesLabels[value] || defaultValue
    }

    const getFrequencyValue = (fieldName, defaultValue) => {
        const frequenciesLabels = {'HOUR':'Hourly', 'MONTH':'Monthly', 'YEAR':'Annual'}
        const value = props.getValue(fieldName, defaultValue)
        return frequenciesLabels[value] || defaultValue
    }

    const showOptionsCurrency = fieldName => (event) => {
        setAnchorEl(event.currentTarget);
        setOptionField(fieldName)
        setMenuOptions([
            {
                value: 'ILS',
                label: '₪',
            }, {
                value: 'USD',
                label: '$',
            }, {
                value: 'EUR',
                label: '€',
            }, {
                value: 'GBP',
                label: '£'
            }
        ])
    }

    const showOptionsFrequency = fieldName => (event) => {
        setAnchorEl(event.currentTarget);
        setOptionField(fieldName)
        setMenuOptions([
            {
                value: 'HOUR',
                label: 'Hourly',
            }, {
                value: 'MONTH',
                label: 'Monthly',
            }, {
                value: 'YEAR',
                label: 'Annual',
            }
        ])
    }
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelectValue = value => () => {
        setAnchorEl(null);
        props.handleChangeField(optionField, value)
    }

    const classes = useStyles();

    return (
        <Grid container spacing={3}>
            {fields.map(field =>
                <Fragment key={field.name}>
                    {!field.hide&&<>
                    {showData?<>
                        <Grid item sm={field.sm || 6} xs={field.xs || 12}>
                            <Typography dir="auto"><strong>{field.label}</strong></Typography>
                            {(() => {
                                switch (field.type) {
                                    case FIELD_TYPES.CASH:
                                        return <Typography dir="auto" style={{textAlign:'left'}}>
                                            {displayCash({value:props.getValue(field.name, ''), 
                                                currency:props.getValue(field.curField, ''), 
                                                frequency:props.getValue(field.freqField, '')
                                            })}
                                        </Typography>
                                    default:
                                        return <Typography dir="auto" style={{textAlign:'left'}}>{props.getValue(field.name, field.defaultValue)}</Typography>
                                    }
                            })()}
                        </Grid>
                    </>:<>
                    {(field.type===FIELD_TYPES.DISPLAY_COMPONENT)&&<Grid item sm={field.sm || 6} xs={field.xs || 12}>
                        {field.component}
                    </Grid>}
                    {(field.type===FIELD_TYPES.TEXT)&&<Grid item sm={field.sm || 6} xs={field.xs || 12}>
                        <Box display="flex" alignItems="center">
                            <TextField
                                variant="standard"
                                name={field.name}
                                label={field.label}
                                margin="none"
                                fullWidth
                                InputProps={{
                                    style: { fontSize: props.fontSize || 16 },
                                    startAdornment: field.startAdornment,
                                    endAdornment: field.endAdornment
                                }}
                                InputLabelProps={{style: { fontSize: props.fontSize || 16 }, }}
                                required={field.required||false}
                                value={props.getValue(field.name, field.defaultValue)}
                                onChange={field.inputType==='color'?handleChangeWithDelay:props.handleChange}
                                helperText={field.helperText}
                                type={field.inputType}
                                onFocus={props.handleFocus}
                                onBlur={props.handleBlur}
                                placeholder={field.placeholder}
                                inputRef={props.focus===field.name?input => input && input.focus():undefined} />
                            {field.afterField&&<>{field.afterField}</>}
                        </Box>
                    </Grid>}
                    {(field.type===FIELD_TYPES.DATE_TIME)&&<Grid item sm={field.sm || 6} xs={field.xs || 12}>
                        <TextField
                            variant="standard"
                            type="datetime-local"
                            name={field.name}
                            label={field.label}
                            margin="none"
                            fullWidth
                            value={props.getValue(field.name, field.defaultValue).substr(0, 16)}
                            onChange={props.handleChange}
                            required={field.required||false}
                            InputLabelProps={{shrink: true}} />
                    </Grid>}
                    {(field.type===FIELD_TYPES.DATE2)&&<Grid item sm={field.sm || 6} xs={field.xs || 12}>
                        <TextField
                            variant="standard"
                            type="date"
                            name={field.name}
                            label={field.label}
                            margin="none"
                            fullWidth
                            value={props.getValue(field.name, field.defaultValue).substr(0, 10)}
                            onChange={props.handleChange}
                            required={field.required||false}
                            InputLabelProps={{shrink: true}}
                            inputRef={props.focus===field.name?input => input && input.focus():undefined}
                            inputProps={{lang:"GB"}} />
                    </Grid>}
                    {(field.type===FIELD_TYPES.MULTILINE)&&<Grid item sm={field.sm || 6} xs={field.xs || 12}>
                        {field.withBold?<BoldToggle field={field} fieldsProps={props}/>:
                        <TextField name={field.name} label={field.label} margin="none" fullWidth variant={field.variant || 'standard'}
                            required={field.required||false} value={props.getValue(field.name, field.defaultValue)} onChange={props.handleChange}
                            multiline type={field.inputType} minRows={field.rows} maxRows={field.rowsMax} onFocus={props.handleFocus} onBlur={props.handleBlur}  placeholder={field.placeholder}
                            inputRef={props.focus===field.name?input => input && input.focus():undefined}
                            helperText={
                                <span style={{ whiteSpace: 'pre-line' }}>
                                    {field.helperText}
                                </span>
                            }
                        />}
                    </Grid>}
                    {(field.type===FIELD_TYPES.SELECT)&&<Grid item sm={field.sm || 6} xs={field.xs || 12}>
                        <FormControl variant="standard" fullWidth required={field.required||false}>
                            <InputLabel shrink  htmlFor={field.name}>{field.label}</InputLabel>
                            <Select
                                variant="standard"
                                value={props.getValue(field.name, field.defaultValue)}
                                onChange={props.handleChange}
                                placeholder={field.placeholder}
                                name={field.name}
                                type={field.inputType}
                                displayEmpty={field.displayEmpty}>
                                {field.options&&field.options.map(option => (
                                    <MenuItem  
                                        key={(option.value === undefined) ? option.label : option.value} 
                                        value={(option.value === undefined) ? option.label : option.value} 
                                        disabled={option.isGroupTitle}
                                        style={option.isGroupTitle?{fontWeight: 700, opacity: 1}:{}}
                                    >
                                        {option.icon&&<ListItemIcon>
                                            {option.icon}
                                        </ListItemIcon>}
                                        <Typography variant="inherit">{option.label}</Typography>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>}
                    {(field.type===FIELD_TYPES.SELECT_MULTIPLE)&&<Grid item sm={field.sm || 6} xs={field.xs || 12}>
                        <FormControl variant="standard" fullWidth required={field.required||false}>
                            <InputLabel shrink  htmlFor={field.name}>{field.label}</InputLabel>
                            <Select
                                variant="standard"
                                value={props.getValue(field.name, field.defaultValue)}
                                multiple
                                onChange={props.handleChange}
                                placeholder={field.placeholder}
                                name={field.name}
                                type={field.inputType}
                                displayEmpty={field.displayEmpty}
                                renderValue={(selected) => (
                                    <div className={classes.chips}>
                                        {selected.map((value) => (
                                            <Chip key={value} label={(field.optionsLabels||[])[value] || value} className={classes.chip} />
                                        ))}
                                    </div>
                                )}>
                                {field.options&&field.options.map(option => (
                                    <MenuItem  
                                        key={(option.value === undefined) ? option.label : option.value} 
                                        value={(option.value === undefined) ? option.label : option.value} 
                                        disabled={option.isGroupTitle}
                                        style={option.isGroupTitle?{fontWeight: 700, opacity: 1}:{}}
                                    >
                                        {option.icon&&<ListItemIcon>
                                            {option.icon}
                                        </ListItemIcon>}
                                        <Typography variant="inherit">{option.label}</Typography>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>}
                    {(field.type===FIELD_TYPES.RADIO)&&<Grid item sm={field.sm || 6} xs={field.xs || 12}>
                        <FormControl variant="standard" component="fieldset" error={field.error}>
                            <FormLabel component="legend">{field.label} {field.required?'*':''}</FormLabel>
                            <RadioGroup aria-label={field.label} name={field.name} value={props.getValue(field.name, field.defaultValue)} onChange={props.handleChange}>
                                <Grid container spacing={0}>                                
                                {field.options&&field.options.map(option => (
                                    <Grid key={option.value || option.label} item sm={6} xs={12}>
                                    <FormControlLabel value={option.value||option.label} control={<Radio color='primary'/>} label={option.label} />
                                    </Grid>
                                ))}
                                </Grid>
                            </RadioGroup>
                        </FormControl>
                    </Grid>}

                    {(field.type===FIELD_TYPES.CHECK_BOX_GROUP)&&<Grid item sm={field.sm || 6} xs={field.xs || 12}>
                        <FormControl variant="standard" component="fieldset" error={field.error}>
                            <FormLabel component="legend">{field.label} {field.required?'*':''}</FormLabel>
                            {field.options&&field.options.map(option => (
                                <FormControlLabel key={option.value || option.label}
                                    control={<Checkbox color='primary' checked={props.getValue(option.name, option.defaultValue)||false} onChange={handleChangeCheckBox} name={option.name} />}
                                    label={option.label} disabled={field.disabled||false}
                                />
                            ))}
                        </FormControl>
                    </Grid>}                    
                    {(field.type===FIELD_TYPES.RADIO_ICONS)&&<Grid item sm={field.sm || 6} xs={field.xs || 12}>
                        <FormControl variant="standard" error={field.error}>
                            <FormLabel component="legend">{field.label} {field.required?'*':''}</FormLabel>
                        </FormControl>
                        <div>
                        <BottomNavigation 
                            showLabels 
                            value={field.options.findIndex(option => (option.value || option.label) === (props.getValue(field.name, field.defaultValue)))}
                            onChange={(event, newValue) => {
                                props.handleChange({target:{name:field.name, value:field.options[newValue].label}})
                            }}>
                            {field.options&&field.options.map(option => (
                                <BottomNavigationAction 
                                    key={option.value || option.label} 
                                    label={option.label} 
                                    icon={option.icon} 
                                    classes={{ selected: "selectedRadioIcon" }}  
                                />
                            ))}
                        </BottomNavigation>
                            {
                                /*
                                <Button key={option.value || option.label}
                                    onClick={()=>{props.handleChange({target:{name:field.name, value:option.value||option.label}})}}
                                    color="primary"
                                    startIcon={option.icon}
                                    variant={(props.getValue(field.name, field.defaultValue) === (option.value||option.label))?'contained':'outlined'}
                                    style={{marginRight:8}}
                                >{option.label}</Button>
                                */
                            }
                        </div>
                    </Grid>}
                    {(field.type===FIELD_TYPES.LOCATION)&&<Grid item sm={field.sm || 6} xs={field.xs || 12}>
                        <LocationField
                            handleLocationChange={props.handleLocationChange} 
                            locationText={field.value || ''} 
                            setLocationText={props.handleLocationType}  
                            label={field.label}
                            margin="none" 
                            fullWidth
                            required={field.required||false}
                        />
                    </Grid>}
                    {/*(field.type===FIELD_TYPES.DATE)&&<Grid item sm={field.sm || 6} xs={field.xs || 12}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                                margin="none" fullWidth disableFuture={props.disableFuture} openTo="year" format="dd/MM/yyyy" views={["year", "month", "date"]}
                                label={field.label} value={props.getDateValue(field.name)} onChange={(date)=>props.handleChangeField(field.name, date)} required={props.required}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>*/}
                    {(field.type===FIELD_TYPES.CHECK_BOX)&&<Grid item sm={field.sm || 6} xs={field.xs || 12}>
                        <FormControlLabel
                            control={<Checkbox color='primary' checked={props.getValue(field.name, field.defaultValue)} onChange={handleChangeCheckBox} name={field.name} />}
                            label={field.label} disabled={field.disabled||false} labelPlacement={field.labelPlacement||'end'}
                        />
                    </Grid>}
                    {(field.type===FIELD_TYPES.CASH)&&<Grid item sm={field.sm || 6} xs={field.xs || 12}>
                        <TextField
                            variant="standard"
                            name={field.name}
                            label={field.label}
                            margin="none"
                            fullWidth
                            required={field.required||false}
                            value={props.getValue(field.name, field.defaultValue)}
                            onChange={props.handleChange}
                            helperText={field.helperText}
                            type="number"
                            onBlur={props.handleBlur}
                            placeholder={field.placeholder}
                            InputProps={{endAdornment: <InputAdornment position="end">
                                <span onClick={showOptionsCurrency(field.curField)} style={{marginRight: 8, cursor: 'pointer'}}>{getCurrencyValue(field.curField, 'ILS')}</span>
                                <span onClick={showOptionsFrequency(field.freqField)} style={{cursor: 'pointer'}}>{getFrequencyValue(field.freqField, 'MONTH')}</span>
                            </InputAdornment>}} />
                    </Grid>}   
                    {(field.type===FIELD_TYPES.TITLE)&&<FieldTitle field={field} getValue={props.getValue}/>}  
                    </>}
                    </>}
                </Fragment>)
            }

            <Menu
                id="options"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {menuOptions.map(option => (
                    <MenuItem key={option.value} value={option.value} onClick={handleSelectValue(option.value)}>
                        {option.label}
                    </MenuItem>
                ))}
            </Menu>
        </Grid>
    );
}